<div class="chip" [class.selected]="selected">
  <ng-content> </ng-content>
</div>
